import { render, staticRenderFns } from "./QuickLinkEdit.vue?vue&type=template&id=1c65ffd3&scoped=true&"
import script from "./QuickLinkEdit.vue?vue&type=script&lang=js&"
export * from "./QuickLinkEdit.vue?vue&type=script&lang=js&"
import style0 from "./QuickLinkEdit.vue?vue&type=style&index=0&id=1c65ffd3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c65ffd3",
  null
  
)

export default component.exports